import React from "react";
import { Menu, MenuItem, ListItemIcon } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";

/**
 * EditDeleteMenu
 *
 * @param {Object} props Component props
 * @param {HTMLElement} [props.anchorEl] The element to which the menu is anchored
 * @param {boolean} [props.open=false] Whether the menu is open
 * @param {function} [props.onClose=() => {}] Function called when the menu is closed
 * @param {function} [props.onEdit=() => {}] Function called when the edit button is clicked
 * @param {function} [props.onDelete=() => {}] Function called when the delete button is clicked
 * @param {boolean} [props.canEdit=false] Whether the edit button is visible
 * @param {boolean} [props.canDelete=false] Whether the delete button is visible
 *
 * @returns A menu component that displays edit and delete buttons
 */

export const EditDeleteMenu = ({
  anchorEl = null,
  open = false,
  onClose = () => {},
  onEdit = () => {},
  onDelete = () => {},
  canEdit = false,
  canDelete = false,
}) => {
  if (!canEdit && !canDelete) return null;
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      slotProps={{
        paper: {
          sx: {
            borderRadius: 3,
            boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
          },
        },
      }}
    >
      {canEdit && (
        <MenuItem
          onClick={onEdit}
          sx={{
            fontSize: 12,
            "&:hover": { backgroundColor: "#e8f0fe" },
            "&:active": { backgroundColor: "#d0e2ff" },
          }}
        >
          <ListItemIcon>
            <Edit fontSize="small" />
          </ListItemIcon>
          Edit
        </MenuItem>
      )}

      {canDelete && (
        <MenuItem
          onClick={onDelete}
          sx={{
            fontSize: 12,
            "&:hover": { backgroundColor: "#fdecea" },
            "&:active": { backgroundColor: "#f9d5d3" },
          }}
        >
          <ListItemIcon>
            <Delete fontSize="small" color="error" />
          </ListItemIcon>
          Delete
        </MenuItem>
      )}
    </Menu>
  );
};
